const http = async <T>(request: RequestInfo): Promise<T> => {
    const response = await fetch(request);
    let body: any = null;
    try {
        body = await response.json();
    } catch (ex) { }

    // Antes, si el body llegaba a parsear como JSON (por ejemplo el {"error":"..."} que
    // devuelven los endpoints protegidos por JWT cuando falta o es invalido el Authorization
    // header), esta funcion lo devolvia como si fuera una respuesta exitosa sin fijarse en
    // response.ok -- asi termino un {"error":"No autorizado."} usado como si fuera la lista de
    // organizationIds en withValidations.jsx, produciendo un filter={"id":{"error":...}} que
    // rompia la API con un JsonSerializationException sin manejar. Ahora cualquier respuesta
    // no-ok siempre lanza, tenga o no un body JSON parseable, para que los try/catch que ya
    // existen alrededor de los llamados a http() puedan actuar como fallback real.
    if (!response.ok) {
        throw new Error(body?.message ?? body?.error ?? response.statusText);
    }

    return body as T;
}

export { http };